import { db, rootRef } from './firebase';
import { AUTH_LINKS_COLLECTION } from './authAccount';

/**
 * HR: 계정 사용 중지/복구.
 * - members.disabled 플래그
 * - pf_auth_links 제거 (즉시 규칙상 hasLink 실패)
 * Firebase Auth 사용자 disable은 Admin SDK 필요 → Functions 후속 (콘솔에서 수동 가능)
 */
export async function setMemberDisabled(
  memberId: string,
  disabled: boolean,
  byMemberId?: string
): Promise<void> {
  const ref = rootRef().collection('members').doc(memberId);
  const snap = await ref.get();
  if (!snap.exists) throw new Error('MEMBER_NOT_FOUND');
  const authUid = snap.data()?.authUid as string | undefined;

  await ref.set(
    {
      disabled,
      disabledAt: disabled ? Date.now() : null,
      disabledBy: disabled ? byMemberId || null : null,
      enabledAt: disabled ? null : Date.now(),
    },
    { merge: true }
  );

  if (disabled && authUid) {
    await db.collection(AUTH_LINKS_COLLECTION).doc(authUid).delete().catch(() => {});
  }
}

export function isMemberDisabled(member: { disabled?: unknown } | null | undefined): boolean {
  return member?.disabled === true;
}
